import { AfgCustomerDomain, CustomerDomain } from '@ally/data-types-host'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import { pluralize } from './common'

dayjs.extend(relativeTime)

export type SecurityType = 'FALLBACK' | 'TIER1' | 'TIER2' | 'TIER3'
enum SecurityEnum {
  FALLBACK = 'FALLBACK',
  TIER1 = 'TIER1',
  TIER2 = 'TIER2',
  TIER3 = 'TIER3',
}

export function getSecurityType(progress: number): SecurityType {
  if (progress !== 0 && !progress) return SecurityEnum.FALLBACK
  if (progress <= 3) return SecurityEnum.TIER1
  if (progress >= 4 && progress < 7) return SecurityEnum.TIER2
  if (progress >= 7) return SecurityEnum.TIER3
  return SecurityEnum.FALLBACK
}

export function isOnlineStatement(
  isAfg: boolean,
  legacyCustomer: CustomerDomain | null,
  afgCustomer: AfgCustomerDomain | null,
): boolean {
  const legacyPref = legacyCustomer?.customer?.statementDeliveryPreference ?? ''
  const afgPref = afgCustomer?.data?.meta.deliveryPreference ?? ''
  const onlineStatement = isAfg ? afgPref : legacyPref
  const statementPrefDone = /^online$/i.test(onlineStatement)
  return statementPrefDone
}

export function getProgressText(
  type: string,
  tier1Remainder: number,
  tier2Remainder: number,
): string {
  const ProgressTextLookup = {
    FALLBACK: 'Complete challenges to rank up.',
    TIER1: `Complete ${tier1Remainder} more ${pluralize(
      'challenge',
      tier1Remainder,
    )} to reach Security Scholar`,
    TIER2: `Complete ${tier2Remainder} more ${pluralize(
      'challenge',
      tier2Remainder,
    )} to reach Security Graduate`,
    TIER3: 'Congrats on becoming a Security Graduate',
  }
  return ProgressTextLookup[type as keyof typeof ProgressTextLookup]
}
